<template>
  <div class="delete-collection">
    <h1>{{ $t('delete_confirm') }}</h1>
    <div class="button-container">
      <button class="button-submit delete-btn" type="submit" @click="deleteCollection">
        {{ $t('delete') }}
      </button>

      <router-link class="collection-add" to="/collections">
        <button class="button-submit delete-btn" type="submit">
          {{ $t('cancel') }}
        </button>
      </router-link>
    </div>
    <div class="error">{{ this.error_message }}</div>
    <div class="success">{{ this.success_message }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { api } from '@/api';
import { errorHandler } from '@/mixins';

export default {
  name: 'Collection',
  components: {},
  mixins: [errorHandler],
  computed: {
    ...mapState(['auth', 'collection'])
  },
  watch: {},
  data() {
    return {
      collection_id: this.$route.params.id,
      error_message: '',
      success_message: ''
    };
  },

  methods: {
    deleteCollection() {
      console.log('deleteCollection', this.collection_id);
      this.error_message = '';
      this.success_message = '';
      api
        .delete(`/collections/${this.collection_id}`)
        .then((res) => {
          console.log('res', res);
          if (!res || res.error || res.message) {
            this.error_message = 'Failed to delete collection';
            return;
          }
          this.success_message = 'Collection deleted successfully';
          window.setTimeout(this.redirectToCollections, 1000);
        })
        .catch((error) => {
          console.error('error', error);
          this.error_message = 'Failed to delete collection';
        });
    },
    redirectToCollections() {
      console.log('redirectToCollections');
      window.location.href = `${window.location.origin}/collections`;
    }
  }
};
</script>

<style lang="scss">
.button-container {
  display: flex;
  justify-content: space-between;
}

.delete-btn:hover {
  cursor: pointer;
}

.delete-collection {
  &__line {
    display: flex;
  }

  .error {
    margin-top: 20px;
    color: red;
  }

  .success {
    margin-top: 20px;
    color: green;
  }
}
</style>
